// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#type-passenger[data-v-b9fd7aa4]  .vs__actions{display:none}", ""]);
// Exports
module.exports = exports;
